import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { PaymentMethodResponse } from '../../../models/payment-method-response.interface';
import { FormUtility } from '../../../../../shared/utils';
import { PaypointService } from '../../../services/paypoint.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'kt-bridgepay-wallet-selection-payment',
  templateUrl: './wallet-selection-payment.component.html',
  styleUrls: ['./wallet-selection-payment.component.scss'],
})
export class WalletSelectionPaymentComponent implements OnInit {
  @Input() customerId: string;
  @Input() organization: string;
  paymentMethods: PaymentMethodResponse[] = [];
  creditCards: PaymentMethodResponse[] = [];
  bankAccounts: PaymentMethodResponse[] = [];
  @Output() methodSelected = new EventEmitter<PaymentMethodResponse>();
  selectedMethod: PaymentMethodResponse | null = null;
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private formUtility: FormUtility,
    private cd: ChangeDetectorRef,
    private paypointService: PaypointService,
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      cards: ['', [Validators.required]],
    });
    this.loadPaymentMethods();
    this.getFormControl('cards').valueChanges.subscribe((res: PaymentMethodResponse) => {
      this.selectMethod(res);
    });
  }

  loadPaymentMethods(): void {
    this.paymentMethods = [];
    this.paypointService
      .getPaymentMethods(this.organization, this.customerId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.paymentMethods = response.data;
          this.creditCards = this.paymentMethods.filter(
            (paymentMethod) => paymentMethod.type === 'card',
          );
          this.bankAccounts = this.paymentMethods.filter(
            (paymentMethod) => paymentMethod.type === 'ach',
          );
          this.cd.detectChanges();
        },
        error: () => {
          // TODO: Handle error gracefully
        },
        complete: () => {
          this.cd.detectChanges();
        },
      });
  }

  getMaskedNumber(method: PaymentMethodResponse) {
    if (method.type === 'card' && method.is_default) {
      return (
        `<span>•••• •••• •••• ${method.token_data.data.card?.last4}</span>` +
        `<span class=" ks-border-radius-lg ks-ml-4 ks-w-20 ks-badge-sm ks-badge-tertiary primary-method-badge">Primary</span>`
      );
    }
    if (method.type === 'ach' && method.is_default) {
      return (
        `<span>•••• •••• •••• ${method.token_data.data.bank?.account_number_last4}</span>` +
        `<span class=" ks-border-radius-lg ks-ml-4 ks-w-20 ks-badge-sm ks-badge-tertiary primary-method-badge">Primary</span>`
      );
    }
    if (method.type === 'card') {
      return `•••• •••• •••• ${method.token_data.data.card?.last4}`;
    }
    if (method.type === 'ach') {
      return `•••• •••• •••• ${method.token_data.data.bank?.account_number_last4}`;
    }
    return '';
  }

  getIconSource(method: PaymentMethodResponse) {
    if (method.type === 'card') {
      return `assets/media/svg/icons/Payment/${method.brand}.svg`;
    }
    return '';
  }
  selectMethod(method: PaymentMethodResponse): void {
    this.selectedMethod = method;
    this.methodSelected.emit(method);
  }

  getFormControl(name: string): FormControl {
    return this.formUtility.getFormControl(this.formGroup, name);
  }
}
